import React, { Component } from 'react';
import { Link } from 'react-router';

import OrganizationSelect from "../../components/OrganizationSelect";
import Pagination from "../../components/Pagination";
import ApplicationStore from "../../stores/ApplicationStore";
import SessionStore from "../../stores/SessionStore";
import OrganizationStore from "../../stores/OrganizationStore";
import MessageBox from "../../components/MessageBox";

class CopyOrganizationModal extends Component {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
    this.state = {
      nowOrgName: "",
      organizations: [],
    };
  }

  componentDidMount() {
   
  }

  componentDidUpdate(prevProps) {
    if (this.props.nowOrgID && this.props.nowOrgID !== prevProps.nowOrgID){
      OrganizationStore.getAll("", 999999, 0, (totalCount, organizations) => {
        this.setState({nowOrgName: organizations.find(org => org.id === this.props.nowOrgID).name})
        const filteredOrganizations = organizations.filter(v => v.id !== this.props.nowOrgID && (SessionStore.isOrganizationAdmin(v.id)||SessionStore.isAdmin()));
        if (SessionStore.isAdmin() && false) {
          this.props.onCopyToChange(0);
        } else if(filteredOrganizations.length > 0){
          this.props.onCopyToChange(filteredOrganizations[0].id);
        }
        this.setState({ organizations: filteredOrganizations });
      });
    }
  }
  
  onChange = (e) => {
      this.props.onCopyToChange(parseInt(e.target.value, 10))
  }

  render () {
    return (
      <div className="modal" tabindex="-1" style={{ display: this.props.showModal ? 'block' : 'none' }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Copy Organization</h5>
            </div>
            <div className="modal-body">
              <label style={{fontSize: '16px'}}>Source organization</label>
              <p className='mySelect'>{this.state.nowOrgName}</p>
              <label style={{fontSize: '16px'}}>Destination organization</label>
              <select className="form-control mySelect" id="orgName" name="orgName" onChange={this.onChange.bind(this)}>
              {(SessionStore.isAdmin()&&false) && <option key={0} value={0}>New </option>}
              {this.state.organizations.map(org => (
                <option key={org.id} value={org.id}>{org.name}</option>
              ))}
              </select>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Cencel</button>
              <button type="button" className="btn btn-primary" onClick={this.props.copyOrganization}>OK</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


class SearchBox extends Component {
  constructor() {
    super();

    this.state = {
      searchText: "",
    };
  }

  onTextChange (e) {
    let v = e.target.value

    this.setState({
      searchText: e.target.value,
    });

    if (this.props.onSearch) {
      this.props.onSearch(v);
    }
  }

  render () {
    return (
      <div>
        <label>
          <input type="text" placeholder="input key to search" value={this.state.searchText || ''} onChange={this.onTextChange.bind(this)} /> &nbsp;&nbsp;&nbsp;&nbsp;
        </label>
      </div>
    );
  }
}

class ApplicationRow extends Component {
  render () {
    var typeName = "unknow";
    switch (this.props.application.appType) {
      case 0:
        typeName = "LoRa meter";
        break;
      case 1:
        typeName = "RS485 bridge";
        break;
      case 2:
        typeName = "RS485 slave meter";
        break;
      case 3:
        typeName = "RS485 DLMS Energy Meter";
        break;
      case 4:
        typeName = "LED light";
        break;
      case 5:
        typeName = "EDMI Mk10E Energy Meter";
        break;
      case 6:
        typeName = "Liquid Level Sensor";
        break;
      case 1001:
        typeName = "Transparent transmission";
        break;
      case 1002:
        typeName = "Winext temperature humidity sensor";
        break;
      case 1003:
        typeName = "Cayenne LPP sensor";
        break;
      case 1004:
        typeName = "Vaccine box sensor";
        break;
      case 1005:
        typeName = "Bathroom Odor Detector Sensor";
        break;
      case 1006:
        typeName = "Indoor Ambiance Monitoring Sensor";
        break;
      case 1007:
        typeName = "PIR & Light Sensor";
        break;
      case 1008:
        typeName = "People Counter";
        break;
      case 1009:
        typeName = "Toilet Paper Sensor";
        break;      
      case 1010:
        typeName = "Toilet Bin Sensor";
        break;

      default:
        typeName = "type=" + this.props.application.AppType;
        break;
    }
    var extPath = this.props.application.appType !== 2 ? "" : "/subMeter/list";

    return (
      <tr>
        <td>{this.props.application.id}</td>
        <td><Link to={`/organizations/${this.props.application.organizationID}/applications/${this.props.application.id}${extPath}`}>{this.props.application.name}</Link></td>
        <td>{typeName}</td>
        <td>{this.props.application.description}</td>
      </tr>
    );
  }
}

class ListApplications extends Component {
  constructor() {
    super();

    this.state = {
      pageSize: 20,
      applications: [],
      organization: {},
      isAdmin: false,
      pageNumber: 1,
      pages: 1,
      searchText: "",
      showModal: false,
      copyToOrgID: null,
    };
    this.copyOrganization = this.copyOrganization.bind(this);
    this.copyOrganizationShow = this.copyOrganizationShow.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updatePage = this.updatePage.bind(this);
  }

  componentDidMount () {
    this.updatePage(this.props);

    SessionStore.on("change", () => {
      this.setState({
        isAdmin: SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(this.props.params.organizationID),
      });
    });
  }

  componentWillReceiveProps (nextProps) {

    this.updatePage(nextProps);
  }

  updatePage (props) {
    this.setState({
      isAdmin: SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(props.params.organizationID),
    });

    OrganizationStore.getOrganization(props.params.organizationID, (org) => {
      this.setState({
        organization: org,
      });
    });

    const page = (props.location.query.page === undefined) ? 1 : props.location.query.page;

    ApplicationStore.getAllForOrganization(props.params.organizationID, this.state.pageSize, (page - 1) * this.state.pageSize, this.state.searchText, (totalCount, applications) => {
      this.setState({
        applications: applications,
        pageNumber: page,
        pages: Math.ceil(totalCount / this.state.pageSize),
      });
      window.scrollTo(0, 0);
    });
  }

  updateSearchPage (props) {
    this.setState({
      isAdmin: SessionStore.isAdmin() || SessionStore.isOrganizationAdmin(props.params.organizationID),
    });

    OrganizationStore.getOrganization(props.params.organizationID, (org) => {
      this.setState({
        organization: org,
      });
    });

    const page = (props.location.query.page === undefined) ? 1 : props.location.query.page;

    ApplicationStore.getAllSearchForOrganization(props.params.organizationID, this.state.pageSize, (page - 1) * this.state.pageSize, this.state.searchText, (totalCount, applications) => {
      this.setState({
        applications: applications,
        pageNumber: page,
        pages: Math.ceil(totalCount / this.state.pageSize),
      });
      window.scrollTo(0, 0);
    });
  }

  startTimer () {
    this.TimerID = setInterval(() => {
      this.updateSearchPage(this.props);
    }, 5000);
  }

  stopTimer () {
    if (this.TimerID !== undefined) {
      clearInterval(this.TimerID);
      this.TimerID = undefined
    }
  }

  onSearchCallback (text) {
    this.setState({
      searchText: text,
    }, () => {
      this.updateSearchPage(this.props);
    });
  }

  handleCopyToChange(id){
    this.setState({ copyToOrgID: id });
  }

  copyOrganizationShow() {
    //超级用户才可以新建
    if (this.state.copyToOrgID === null) {
      MessageBox.showAlert("Cannot be copied to other organizations","warning")
      return
    }
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  copyOrganization() {
    //再来一个提示框避免误操作
    if (confirm("Are you sure to copy this organization into another organization?")){
      this.setState({ showModal: false });
      OrganizationStore.CopyOrganization(this.state.organization.id,this.state.copyToOrgID,(res)=>{
        MessageBox.showAlert("Copy Success","success")
      })
      console.log(this.state.organization.id,this.state.copyToOrgID);
    }
  }

  render () {
    const ApplicationRows = this.state.applications.map((application, i) => <ApplicationRow key={application.id}  application={application} />);

    return (
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><OrganizationSelect organizationID={this.props.params.organizationID} /></li>
          <li className="active">Applications</li>
        </ol>
        <div className="clearfix">
          <div className="pull-left">
            <SearchBox onSearch={this.onSearchCallback.bind(this)}></SearchBox>
          </div>
          <div className="btn-group pull-right" role="group" aria-label="...">
            &nbsp; <Link className={(this.state.isAdmin ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/applications/create`}><button type="button" className="btn btn-default">Create application</button></Link>
            &nbsp; <Link className={(this.state.isAdmin ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/users`}><button type="button" className="btn btn-default">Share Organization</button></Link>
            &nbsp; <Link className={(this.state.isAdmin ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/edit`}><button type="button" className="btn btn-default">Edit organization</button></Link>
            &nbsp; <Link className={(this.state.isAdmin ? '' : 'hidden')}><button type="button" onClick={this.copyOrganizationShow} className="btn btn-default">Copy organization</button></Link>
            &nbsp; <Link className={(this.state.organization.canHaveGateways ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/gateways`}><button type="button" className="btn btn-default">Gateways</button></Link>
          </div>
          <CopyOrganizationModal nowOrgID={this.state.organization.id} showModal={this.state.showModal} closeModal={this.closeModal} copyToOrgID={this.setState.copyToOrgID} copyOrganization={this.copyOrganization.bind(this)} onCopyToChange={this.handleCopyToChange.bind(this)}/>
        </div>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th className="col-md-1">ID</th>
                  <th className="col-md-4">Name</th>
                  <th className="col-md-4">Type</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {ApplicationRows}
              </tbody>
            </table>
          </div>
          <Pagination pages={this.state.pages} currentPage={this.state.pageNumber} pathname={`/organizations/${this.props.params.organizationID}`} />
        </div>
      </div>
    );
  }
}

export default ListApplications;



// WEBPACK FOOTER //
// ./src/views/applications/ListApplications.js